import { useState, useCallback } from 'react';
import { j218Api } from '../../../services/j218Api';

export function useJ218Navigation(loadRecordWithNames: (id: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  const loadList = useCallback(async (): Promise<string[]> => {
    const resp = await j218Api.list(1, 9999);
    const ids = resp.data.map(r => r.fj730_01);
    setAllIds(ids);
    return ids;
  }, []);

  const navTo = useCallback(async (idx: number) => {
    if (idx < 0 || idx >= allIds.length) return;
    setCurrentIdx(idx);
    await loadRecordWithNames(allIds[idx]);
  }, [allIds, loadRecordWithNames]);

  return { allIds, currentIdx, setCurrentIdx, loadList, navTo };
}
